var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiCreateSpace } from '@/infrastructure/api-functions/api-create-space';
import { SpaceType } from '../enums';
import { FOREVER_TS } from '../constants';
let CreateSpaceRepositoryImpl = class CreateSpaceRepositoryImpl {
    constructor(_apiCreateSpace) {
        this._apiCreateSpace = _apiCreateSpace;
    }
    async createSpace(data) {
        const request = this._convertRequest(data);
        const response = await this._apiCreateSpace.createSpace(request);
        return this._convertResponse(response, data);
    }
    _convertResponse(response, data) {
        // @ts-ignore todo
        const spaceEntity = {
            spaceId: response.space_id,
            spaceName: response.space_name,
            spaceType: this._getSpaceType(response),
            lastVisitTime: response.latest_access_ts,
            folderCount: response.normal_folder_count,
            isShared: response.is_shared_space,
            isPublic: response.is_public_space,
            permission: {
                share: true,
            },
            isManager: true,
            tags: response.label_names,
            buildInIconId: response.space_icon,
            iconImageUrl: response.icon_image,
        };
        return spaceEntity;
    }
    _convertRequest(data) {
        const addPermissions = this._getAddPermissions(data);
        const result = {
            space_name: data.spaceName,
            add_permissions: addPermissions,
            field_template_id: data.templateId,
            label_ids: data.tags,
        };
        if (data.spaceType === SpaceType.Public) {
            result.public_workspace = true;
            result.add_permissions = undefined;
        }
        return this._setSpaceIcon(data, result);
    }
    _getAddPermissions(data) {
        return (data.permissions || []).map(receiver => ({
            permission_detail: receiver.permission_detail,
            receiver_id: receiver.receiver_id,
            receiver_type: receiver.receiver_type,
            share_expiry_at: FOREVER_TS,
            sync_display_field: false,
            user_role: receiver.user_role,
        }));
    }
    _setSpaceIcon(data, input) {
        const result = { ...input };
        if (data.objectKey) {
            result.space_s3_key = data.objectKey;
        }
        else {
            result.space_icon = data.buildInIconId;
        }
        return result;
    }
    _getSpaceType(type) {
        if (type.is_shared_space) {
            return SpaceType.Shared;
        }
        if (type.is_public_space) {
            return SpaceType.Public;
        }
        return SpaceType.Personal;
    }
};
CreateSpaceRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiCreateSpace)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiCreateSpace !== "undefined" && ApiCreateSpace) === "function" ? _a : Object])
], CreateSpaceRepositoryImpl);
export { CreateSpaceRepositoryImpl };
